module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[54]53.0277339.woff2";